import createReactContext from 'create-react-context';

var HeaderContext = createReactContext({});

export default HeaderContext;
//# sourceMappingURL=HeaderContext.js.map